<!--
    @created        25/06/2023 - 16:49
    @author         Nariman Palangi
    @user           ragnarok  
    @organization   
    @project        home-vuejs
    @file name      Skeleton.vue
    @file dir       src
-->
<script>

export default {
  name: "Skeleton",
  props: {
    minHeight : {
      type: String,
      default: "150px"
    }
  },
  data(){
    return {
      //current screen size
      windowCurrentSize: window.innerWidth,
    }
  },
  computed: {
    //num of items based on current screen size
    itemCount(){
      if(this.windowCurrentSize <= 600) return 1;
      else if(this.windowCurrentSize > 600 && this.windowCurrentSize <= 920) return 2
      else return 4;
    }
  }
}
</script>

<template>
  <div class="row mx-3 justify-content-center align-center">
    <div class="col-lg-10 col-md-10 col-12">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-12 loading-skeleton mt-3" v-for="i in itemCount" :key="i">
          <div class="card w-100">
            <div class="skeleton" :style="{minHeight: minHeight}"></div>
            <div class="card-body">
              <p class="card-title">skeleton title</p>
              <p class="card-text">skeleton text</p>
              <a href="#" class="btn btn-primary">btn</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .skeleton {
    background-color: #d2d2d2;
    border-radius: 8px;
    display: block;
  }
  %loading-skeleton {
     color: transparent;
     appearance: none;
     -webkit-appearance: none;
     background-color: #eee;
     border-color: #eee;

     &::placeholder {
       color: transparent;
     }
   }
  @keyframes loading-skeleton {
    from {
      opacity: .4;
    }
    to {
      opacity: 1;
    }
  }
  .loading-skeleton {
    pointer-events: none;
    animation: loading-skeleton 1s infinite alternate;

    img {
      filter: grayscale(100) contrast(0%) brightness(1.8);
    }
    h1, h2, h3, h4, h5, h6,
    p, li,
    .btn,
    label,
    .form-control {
      @extend %loading-skeleton;
    }
  }
</style>